
// document.addEventListener("DOMContentLoaded", () => {
//   // 🛡️ Защита основной кнопки AddToCart от внешних перехватов
//   if (window.location.pathname.includes("/products/")) {
//     const productForm = document.querySelector('form[action="/cart/add"]');
//     const addToCartBtn = document.getElementById("AddToCart");

//     if (productForm && addToCartBtn) {
//       console.log("🛡️ AddToCart safe mode active");

//       // Разрешаем сабмит Shopify, но блокируем внешние обработчики
//       productForm.addEventListener(
//         "submit",
//         (e) => {
//           // Пропускаем нативный сабмит Shopify (чтобы не ломать AJAX-cart)
//           if (e.isTrusted && e.target === productForm) return;
//           // Блокируем обработчики сторонних виджетов
//           e.stopImmediatePropagation();
//         },
//         true
//       );

//       // То же самое для кликов — блокируем только внешние события
//       addToCartBtn.addEventListener(
//         "click",
//         (e) => {
//           if (!e.isTrusted) e.stopImmediatePropagation();
//           console.log("🛡️ Safe click protection active");
//         },
//         true
//       );
//     }
//   }

//   // 🔹 Делегатор для кнопок апселлов
//   document.body.addEventListener("click", async (event) => {
//     const addonBtn = event.target.closest(".upgrade-btn");
//     if (!addonBtn || addonBtn.closest("form[action='/cart/add']")) return;

//     event.preventDefault();

//     const variantId = addonBtn.dataset.variantId;
//     const priceText = addonBtn.dataset.price || "";
//     const originalText = addonBtn.textContent;

//     if (!variantId) {
//       console.error("❌ Missing variant ID on upgrade button");
//       return;
//     }

//     // Защита от двойного клика
//     if (addonBtn.dataset.loading === "true") return;
//     addonBtn.dataset.loading = "true";
//     addonBtn.disabled = true;
//     addonBtn.textContent = "Adding...";

//     try {
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: variantId, quantity: 1 }),
//       });

//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
//       const item = await response.json();
//       console.log("✅ Add-on added:", item);

//       await updateCartCount();

//       addonBtn.textContent = "Added!";
//       setTimeout(() => {
//         addonBtn.disabled = false;
//         addonBtn.textContent = originalText;
//       }, 1000);
//     } catch (error) {
//       console.error("Add-on add failed:", error);
//       addonBtn.disabled = false;
//       addonBtn.textContent = priceText ? `Add for ${priceText}` : originalText;
//     } finally {
//       addonBtn.dataset.loading = "false";
//     }
//   });

//   // Обновление имени выбранного цвета (если есть radio-опции)
//   const radios = document.querySelectorAll('input[name^="variant-selection-"]');
//   const colorNameEl = document.getElementById("upgrade-selected-color-name");

//   if (radios.length && colorNameEl) {
//     radios.forEach((radio) => {
//       radio.addEventListener("change", () => {
//         const selectedColor = radio.dataset.colorName || "";
//         colorNameEl.textContent = selectedColor;
//       });
//     });
//   }
// });

// // Обновление количества товаров в корзине
// async function updateCartCount() {
//   try {
//     const res = await fetch("/cart.js");
//     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//     const cart = await res.json();
//     const cartCountElement = document.querySelector(".thb-item-count");
//     if (cartCountElement) cartCountElement.textContent = cart.item_count;
//   } catch (error) {
//     console.error("Failed to update cart count:", error);
//   }
// }


// // Форматирование цены
// function Moneyformat(cents) {
//   return (cents / 100).toLocaleString("en-US", {
//     style: "currency",
//     currency: "USD",
//   });
// }


document.addEventListener("DOMContentLoaded", () => {
  // 🛡️ Защита основной кнопки AddToCart от внешних перехватов
  if (window.location.pathname.includes("/products/")) {
    const productForm = document.querySelector('form[action="/cart/add"]');
    const addToCartBtn = document.getElementById("AddToCart");

    if (productForm && addToCartBtn) {
      console.log("🛡️ AddToCart safe mode active");

      // Блокируем внешние submit-обработчики
      productForm.addEventListener(
        "submit",
        (e) => {
          if (e.isTrusted && e.target === productForm) return;
          e.stopImmediatePropagation();
        },
        true
      );

      // Блокируем внешние click-обработчики
      addToCartBtn.addEventListener(
        "click",
        (e) => {
          if (!e.isTrusted) e.stopImmediatePropagation();
        },
        true
      );
    }
  }

  // 🔹 Делегатор для кнопок апселлов
  document.body.addEventListener("click", async (event) => {
    const addonBtn = event.target.closest(".upgrade-btn");
    if (!addonBtn || addonBtn.closest("form[action='/cart/add']")) return;

    event.preventDefault();

    const variantId = addonBtn.dataset.variantId;
    const priceText = addonBtn.dataset.price || "";
    const originalText = addonBtn.textContent;

    if (!variantId) {
      console.error("❌ Missing variant ID on upgrade button");
      return;
    }

    // Защита от двойного клика
    if (addonBtn.dataset.loading === "true") return;
    addonBtn.dataset.loading = "true";
    addonBtn.disabled = true;
    addonBtn.textContent = "Adding...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const item = await response.json();
      console.log("✅ Add-on added:", item);

      await updateCartCount();

      // 🚀 Открываем и обновляем Cart Drawer (Vision theme)
      try {
        if (
          window.Shopify &&
          Shopify.theme &&
          Shopify.theme.cartDrawer &&
          typeof Shopify.theme.cartDrawer.open === "function"
        ) {
          Shopify.theme.cartDrawer.open();
          console.log("🛒 Drawer opened via Shopify.theme.cartDrawer.open()");
        } else if (
          window.theme &&
          theme.cartDrawer &&
          typeof theme.cartDrawer.open === "function"
        ) {
          theme.cartDrawer.open();
          console.log("🛒 Drawer opened via theme.cartDrawer.open()");
        } else {
          // Фолбэк — нативные события + прямое добавление класса
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
          document.dispatchEvent(new CustomEvent("cart:open"));
          const drawerEl = document.getElementById("Cart-Drawer");
          if (drawerEl) {
            drawerEl.classList.add("active");
            console.log("✨ Drawer manually activated (#Cart-Drawer.active)");
          }
        }
      } catch (err) {
        console.warn("Drawer refresh failed:", err);
      }

      addonBtn.textContent = "Added!";
      setTimeout(() => {
        addonBtn.disabled = false;
        addonBtn.textContent = originalText;
      }, 1000);
    } catch (error) {
      console.error("Add-on add failed:", error);
      addonBtn.disabled = false;
      addonBtn.textContent = priceText ? `Add for ${priceText}` : originalText;
    } finally {
      addonBtn.dataset.loading = "false";
    }
  });

  // Обновление имени выбранного цвета (если есть radio-опции)
  const radios = document.querySelectorAll('input[name^="variant-selection-"]');
  const colorNameEl = document.getElementById("upgrade-selected-color-name");

  if (radios.length && colorNameEl) {
    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const selectedColor = radio.dataset.colorName || "";
        colorNameEl.textContent = selectedColor;
      });
    });
  }
});

// Обновление количества товаров в корзине
async function updateCartCount() {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const cart = await res.json();
    const cartCountElement = document.querySelector(".thb-item-count");
    if (cartCountElement) cartCountElement.textContent = cart.item_count;
  } catch (error) {
    console.error("Failed to update cart count:", error);
  }
}

// Форматирование цены
function Moneyformat(cents) {
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}